import { LEGAL_DOCUMENTS, LEGAL_VERSION } from '@estudio/contracts';
export function LegalDocuments() {
  return <section aria-label="Documentos legales">
    <p>Responsable: Santiago Zamora · Barranquilla, Colombia · <a href="mailto:parchack@proton.me">parchack@proton.me</a></p>
    {LEGAL_DOCUMENTS.map(doc=><details key={doc.kind}><summary>{doc.title}</summary><article style={{maxWidth:760,lineHeight:1.65}}>{doc.body.split('\n\n').map((section,i)=>{const [heading,...lines]=section.split('\n');return <section key={i}><h3>{heading}</h3><p>{lines.join('\n')}</p></section>;})}</article></details>)}
    <p className="small muted">Versión {LEGAL_VERSION}. Puedes guardar los documentos con la opción Imprimir de tu navegador.</p>
  </section>;
}
